export default {
  apiToken: '',
  apiUrl: '',
  reduxRoot: 'translate',
  screenshots: false,
  showMissingTranslations: false,
  synchronize: false,
  disableEventSource: false
};